import { right } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

//TODO implement
const GetAIChatsApiImpl = async (params: string): Promise<any> => {

    //https://uwrueozsld.execute-api.us-east-1.amazonaws.com/Prod/list-chats?entity=Bella+Kloberman&timestampFrom=1719723600000&timestampTo=1720310399999&language=en-US&sentimentWhat=average&sentimentWho=caller&sentimentDirection=positive

    const baseUrl = di.get<Constants>(ConstantsName).AI;

    // Build the URL properly
    let url = baseUrl + `/list-chats`;
    
    if (params && params !== "") {
        // Check if limit is already in params
        if (params.includes('limit')) {
            url += `?${params}`;
        } else {
            url += `?limit=20&${params}`;
        }
    } else {
        url += `?limit=20`;
    }

    console.log('GetAIChatsApiImpl - URL:', url);
    console.log('GetAIChatsApiImpl - params:', params);
    
    const response = await callAPI(url, 'GET', {});
    
    //const response2 = await di.get<Host2Api>(Host2ApiName).get(baseUrl);

    const reader = response.body?.getReader();

    if (!reader) {
        throw new Error("Readable stream not supported or body is empty.");
    }
    
    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    // Decoding the last chunk
    result += decoder.decode();
    
    return right(result);
}

export default GetAIChatsApiImpl;
